<template>
  <v-card>
  <v-row class="mx-0">
  <v-col cols="12" sm="12" class="pb-0">
    <h4>Comments</h4>
  </v-col>
    <v-col cols="12" sm="12" class="pb-0">
  <v-virtual-scroll
        :bench="benched"
        :items="comments"
        height="260"
        item-height="64"
      >
      <template v-slot="{ item }">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle class="text--primary" v-text="item.user.name"></v-list-item-subtitle>
            <v-list-item-subtitle v-text="item.message"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
          <v-list-item-action-text v-text="item.user_id"></v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
      </template>
  </v-virtual-scroll>
  </v-col>
  <v-col cols="12" sm="9" class="pt-0">
     <v-textarea
          label="Message"
          v-model="addcomment.message"
          rows="2"
          prepend-icon="mdi-comment"
        ></v-textarea>
  </v-col>
  <v-col cols="12" sm="2" class="pt-6">
     <v-btn color="success" @click="submitcomment()" small>send</v-btn>
  </v-col>
  </v-row>
  </v-card>
</template>

<style scoped>
  .w-100{
    width:100%;
  }
</style>

<script>
import { mapActions } from 'vuex';
  export default {
    props : {
        comments : Array,
        projectid: Number
    },
    data: () => ({
      addcomment : {
        user_id: 1,
        message: ''
      },
      benched: 0,
    }),
    computed: {
      items () {
        return Array.from({ length: this.length }, (k, v) => v + 1)
      },
      length () {
        return 7000
      },
    },
    methods: {
        ...mapActions(['addprojectcomments']),
        submitcomment() {
            if(this.addcomment.message)
            {
                this.addprojectcomments({ projectid : this.projectid,comment : this.addcomment});
                this.addcomment.message = '';
            }else{
              alert("message is required.");
            }

        }
    }
  }
</script>